import React from "react";
import { Modal, Divider, Empty, Typography, Space, Flex } from "antd";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { dataTo12Fn } from "@/utils/date";

const { Title, Text } = Typography;

export default function LeaveDetailModal({ open, data, onCancel }) {
  const annualItems = data?.annualItems || [];
  const sickItems = data?.sickItems || [];

  const renderLeaveCard = (item, color, type) => (
    <div
      key={item.id}
      style={{
        background: "#FBFCFD",
        borderRadius: "12px",
        border: "1px solid #E2E8F0",
        padding: "16px",
        boxShadow:
          type === "annual"
            ? "inset 2px 0px 0px 0px #ADD5C6"
            : "inset 2px 0px 0px 0px #F5B5B5",
      }}
    >
      <Flex align="center" justify="space-between" style={{ marginBottom: 16 }}>
        <Flex align="center" gap={8}>
          <div
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: color,
            }}
          />
          <Text style={{ fontSize: "14px", color: "#0E172B" }}>
            {type === "annual" ? "Annual Leave" : "Sick Leave"}
          </Text>
        </Flex>
        <Text style={{ fontSize: "18px", color: "#0E172B", fontWeight: 500 }}>
          {type === "annual"
            ? `${data?.annualTotalHours || 0}h ${data?.annualTotalMinutes || 0}m`
            : `${data?.sickTotalHours || 0}h ${data?.sickTotalMinutes || 0}m`}
        </Text>
      </Flex>

      <Divider style={{ margin: "12px 0" }} />

      {/* 时间信息行 */}
      <Flex justify="space-between">
        <div>
          <Text style={{ fontSize: "12px", color: "#314157" }}>Start Time</Text>
          <Flex align="center" gap={6} style={{ marginTop: 4 }}>
            <ClockCircleOutlined
              style={{ fontSize: "12px", color: "#94A3B8" }}
            />
            <Text style={{ fontSize: "14px", color: "#0E172B" }}>
              {dataTo12Fn(item.startTime, 1)}
            </Text>
          </Flex>
        </div>
        <div>
          <Text style={{ fontSize: "12px", color: "#314157" }}>End Time</Text>
          <Flex align="center" gap={6} style={{ marginTop: 4 }}>
            <ClockCircleOutlined
              style={{ fontSize: "12px", color: "#94A3B8" }}
            />
            <Text style={{ fontSize: "14px", color: "#0E172B" }}>
              {dataTo12Fn(item.endTime, 1)}
            </Text>
          </Flex>
        </div>
      </Flex>

      {item.remark && (
        <>
          <Divider style={{ margin: "12px 0" }} />
          <div>
            <Text style={{ fontSize: "12px", color: "#314157" }}>Remark</Text>
            <Text
              style={{
                fontSize: "14px",
                color: "#0E172B",
                display: "block",
                marginTop: 4,
              }}
            >
              {item.remark}
            </Text>
          </div>
        </>
      )}
    </div>
  );

  return (
    <Modal
      open={open}
      width={520}
      footer={null}
      onCancel={onCancel}
      maskClosable={false}
      keyboard={false}
      title={
        <div style={{ fontSize: "20px", fontWeight: "bold", color: "#0E172B" }}>
          <CalendarOutlined style={{ marginRight: "8px" }} /> Leave Details
          <Divider style={{ marginTop: 12, marginBottom: 0 }} />
        </div>
      }
      styles={{ body: { minHeight: "250px" } }}
    >
      {!annualItems.length && !sickItems.length ? (
        <Empty description="No Leave Records" />
      ) : (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          {/* Annual Leave */}
          {annualItems.length > 0 && (
            <div>
              {annualItems.map((item) =>
                renderLeaveCard(item, "#ADD5C6", "annual"),
              )}
            </div>
          )}

          {/* Sick Leave */}
          {sickItems.length > 0 && (
            <div>
              {sickItems.map((item) =>
                renderLeaveCard(item, "#F5B5B5", "sick"),
              )}
            </div>
          )}
        </Space>
      )}
    </Modal>
  );
}
